import React, { useState } from "react";
import { Input, Button, Loader } from "../../components";
import { logo_logical } from "../../images";
import { new_login_bg } from "../../images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import {
  send_reset_email,
  vendor_send_reset_email,
} from "../../features/authSlice";
import { useLocation } from "react-router-dom";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const { isLoading, isError, message, isSuccess } = useSelector(
    (state) => state.auth
  );

  const [username, setUsername] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const submitHandler = async (event) => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!username.trim()) {
      errors.username = "Please enter the required field.";
    } else if (!emailRegex.test(username)) {
      errors.username = "Please enter a valid email address.";
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setErrors({});
    event.preventDefault();
    if (
      searchParams.get("userType") &&
      searchParams.get("userType") === "vendor"
    ) {
      try {
        const res = await dispatch(
          vendor_send_reset_email({ email: username })
        );
        if (res.payload.status === 200 || res.payload.status === 201) {
          toast.success(res.payload.data.message);
        } else {
          toast.error(res.payload[0].email);
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            "An error occurred"
        );
      }
    } else {
      try {
        const res = await dispatch(send_reset_email({ email: username }));
        if (res.payload.status === 200 || res.payload.status === 201) {
          toast.success(res.payload.data.message);
        } else {
          toast.error(res.payload[0].email);
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            "An error occurred"
        );
      }
    }
  };
  return (
    <div className="h-screen w-full font-mont flex justify-center items-center">
      <div className="w-full h-screen bg-[#FCC81C] !text-center hidden md:flex justify-center">
        <img src={new_login_bg} className="inline-block" alt="bg_ing" />
      </div>
      <div className="w-full md:w-[600px] max-w-[95%] bg-white flex flex-col justify-  p-4  text-black h-screen">
        <div className="flex w-full justify-center items-center !mb-2">
          <img src={logo_logical} alt="login logo" />
        </div>
        <form className="mt-28">
          <div className="relative">
            <label className="mb-1">Email</label>{" "}
            <span className="capitalize">{searchParams.get("userType")}</span>
            <Input
              id="email"
              placeholder="Email"
              className="bg-white text-[#38015c] border border-[#d7d7d7] w-[98%] text-left py-3 px-2.5 h-[60px]"
              value={username}
              onChange={({ target: { value } }) => setUsername(value)}
              name="email"
            />
            {errors.username && (
              <div className="text-red-500 mt-1 ml-1">{errors.username}</div>
            )}
            <div className="absolute top-11 right-3.7 text-lg text-[#7c7f82]">
              <FontAwesomeIcon icon={faEnvelope} />
            </div>
            {isError || isSuccess ? (
              <div
                className={
                  isError
                    ? "text-[#f00] text-sm mb-3.7 mt-1.5 truncate"
                    : "text-green-500 text-sm mb-3.7 mt-1.5 truncate"
                }
              >
                {message}
              </div>
            ) : null}
          </div>
          <div className="text-black mb-6 flex mt-1.5 px-2.5 justify-center">
            <NavLink
              to={`/login`}
              className="text-primary-100 text-base underline"
            >
              I remembered my password!
            </NavLink>
          </div>
          <div>
            {!isLoading && (
              <Button
                text="Reset Password"
                type="button"
                onClick={submitHandler}
                className="!w-full !rounded-lg bg-primary-100 text-white cursor-pointer !p-4 text-xl font-normal uppercase w-[98%]"
              />
            )}
            {isLoading && <Loader />}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
